//let 改成var
var _MAPSERVICE = "";
if (process.env.NODE_ENV === "development") {
    // _MAPSERVICE = "//localhost:8090/com-mapvision-mapserver";
    _MAPSERVICE = "//geosite.mapvision.com.cn/mapserver";
} else if (process.env.NODE_ENV === "production") {
    _MAPSERVICE = "//geosite.mapvision.com.cn/mapserver";
} else if (process.env.NODE_ENV === "test") {
    _MAPSERVICE = "//192.168.1.120:8090/com-mapvision-mapserver";
}
const paths = {
    _DATA_SERVICE: "/rest/dataservice",
    _AUQUISITION: "/rest/acquisition",
    _POI_SERVICE: "/rest/poi",
}

export default function getPath(key) {
    return _MAPSERVICE + paths[key];
}

